export enum MessageInfo {
  REQUIRED_FIELD = 'This field is required',
  LIMIT_1_AND_10 = 'Please enter a valid param, param should be between 1 and 10 characters long',
  LIMIT_1_AND_100 = 'Please enter a valid param, param should be between 1 and 100 characters long',
  LIMIT_1_AND_255 = 'Please enter a valid param, param should be between 1 and 255 characters long',
  LIMIT_1_AND_1500 = 'param must be between 1 and 1500 characters long',
  LIMIT_1_AND_2000 = 'param must be between 1 and 2000 characters long',
  LIMIT_1_AND_2500 = 'param must be between 1 and 2500 characters long',
  LIMIT_1_AND_4000 = 'param must be between 1 and 4000 characters long',
  LIMIT_1_AND_5000 = 'param must be between 1 and 5000 characters long',
  LIMIT_25_AND_5000 = 'param must be between 25 and 5000 characters long',
  LIMIT_1_AND_20000 = 'param must be between 1 and 20000 characters long',
  LIMIT_1_AND_168 = 'Please enter a valid param, param should be between 1 and 168',
  LIMIT_2_AND_100 = 'Please enter a valid param, param should be between 2 and 100 characters long',
  LIMIT_5_AND_100 = 'Please enter a valid param, param should be between 5 and 100 characters long',
  LIMIT_6_AND_100 = 'Please enter a valid param, param should be between 6 and 100 characters long',
  LIMIT_8_AND_100 = 'Please enter a valid param, param should be between 8 and 100 characters long',
  LIMIT_100_AND_5000 = 'Please enter a valid param, param should be between 100 and 5000 characters long',
  MIN_8_CHAR = 'param must have a minimum of 8 characters',
  ALREADY_EXISTS = 'This param already exists',
  NOT_EXIST = 'param does not exist',
  ALREADY_USED = 'param is already used',
  ONLY_POSITIVE_NR = 'param should contain only positive numbers and without decimal point numbers',
  INVALID_PRICE = ' param must be between 0.5 and 131000',
  INVALID_PERCENTAGE = 'param value must be between 0.5 and 99',
  INVALID_CREDIT_AMOUNT = 'param should not be higher than the Amount of this product',
  INDIVIDUAL_OWNER_TYPE = 'The entered email belongs to an individual',
  ORGANIZATION_OWNER_TYPE = 'The entered email belongs to an organization'
}
